import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! RESPONSIBLE TEAM: team-self-serve }}\n{{yield}}",{ moduleName: "embercom/components/start/body-component.hbs" })